import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import CommonTabSwitcher from 'components/commonTabSwitcher/CommonTabSwitcher';
import { useSelector } from 'react-redux';
import { FaClipboardList, FaUserShield } from 'react-icons/fa';
import AdminUserList from './AdminUserList';
import ActivityLogList from './ActivityLogList';
import { sideBarRoutes } from 'utils/StaticData';

const AdminUserTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { adminDetails } = useSelector((state) => state.authSlice);
  const hasActivityLogAccess =
    adminDetails?.role === sideBarRoutes.Admin ||
    adminDetails?.role === sideBarRoutes.Dealer;

  if (!hasActivityLogAccess) {
    return (
      <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
        <AdminUserList />
      </Box>
    );
  }

  return (
    <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
      <CommonTabSwitcher
        tabs={[
          { label: 'Portal Users', icon: FaUserShield },
          { label: 'Activity Log', icon: FaClipboardList },
        ]}
        activeIndex={tabIndex}
        onChange={setTabIndex}
      />
      {tabIndex === 0 && <AdminUserList />}
      {tabIndex === 1 && <ActivityLogList />}
    </Box>
  );
};

export default AdminUserTabs;
